'use strict';

var _ = require('lodash');
var GridToolbarConfigurationLegAssignmentController = function GridToolbarConfigurationLegAssignmentController($scope, toolbarGridService) {
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDuplicateButtonShown = selectedRows.length === 1;
    $scope.isDeleteButtonShown = selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  };
  function setStructureWithOldValues(loadedData, rowid) {
    loadedData[rowid]._old = {};
    var columns = $scope.jqxGridSettings.columns;
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  $scope.addLegAssignment = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({
      isNewlyAdded: true
    });
    $scope.updateData(loadedData);
    setStructureWithOldValues(loadedData, 0);
  };
  $scope.removeLegAssignment = function () {
    var rows = _.chain($scope.jqxGridSettings.source.loadedData).filter('_old').clone(true).value(true);
    $scope.$emit('configuration-leg-assignment:removeLegAssignment', $scope.selectedRows, rows);
    toolbarGridService.removeRow($scope);
  };
  $scope.duplicateLegAssignment = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndex = $scope.jqxGridSettings.jqxGrid('getselectedrowindex');
    var rowid = $scope.jqxGridSettings.jqxGrid('getrowid', selectedIndex);
    var oldRow = loadedData[rowid];
    var newRow = _.clone(oldRow);
    delete newRow.hepKey;
    loadedData.splice(rowid, 0, newRow);
    $scope.updateData(loadedData);
    setStructureWithOldValues(loadedData, rowid);
  };
  $scope.saveChanges = function () {
    var rows = _.chain($scope.jqxGridSettings.source.loadedData).filter('_old').map(function (row) {
      delete row.isNewlyAdded;
      return row;
    }).clone(true).value(true);
    $scope.$emit('configuration-leg-assignment:saveChanges', rows);
  };
  $scope.$on('configuration-leg-assignment:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
};
GridToolbarConfigurationLegAssignmentController.$inject = ['$scope', 'ToolbarGridService'];
module.exports = GridToolbarConfigurationLegAssignmentController;